import { useEffect, useState } from "react";
import { Link2, X } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

/** Text input with Universe auto-match: suggests companies as you type and stores {value, universe_id, universe_company}. */
export function UniverseLinkInput({ value, universeId, universeCompany, onChange, placeholder, testid, disabled }) {
  const [matches, setMatches] = useState([]);
  useEffect(() => {
    if (universeId || disabled) { setMatches([]); return; }
    const t = setTimeout(async () => {
      if (!(value || "").trim()) { setMatches([]); return; }
      try {
        const { data } = await api.get("/master-data/match", { params: { q: value } });
        setMatches(data || []);
      } catch { setMatches([]); }
    }, 500);
    return () => clearTimeout(t);
  }, [value, universeId, disabled]);
  return (
    <div className="space-y-1.5">
      <Input value={value || ""} onChange={(e) => onChange({ value: e.target.value, universe_id: null, universe_company: "" })}
        placeholder={placeholder} className="h-9" data-testid={testid} disabled={disabled} />
      {universeId ? (
        <span className="inline-flex items-center gap-1 text-[11px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded" data-testid={`${testid}-linked`}>
          <Link2 className="h-3 w-3" /> Universe: {universeCompany}
          <button type="button" onClick={() => onChange({ value, universe_id: null, universe_company: "" })} className="ml-0.5 hover:text-emerald-900" data-testid={`${testid}-unlink`}><X className="h-3 w-3" /></button>
        </span>
      ) : matches.length > 0 && (
        <div className="flex flex-wrap gap-1" data-testid={`${testid}-suggestions`}>
          {matches.slice(0, 3).map((m) => (
            <button key={m.id} type="button" onClick={() => onChange({ value: m.company, universe_id: m.id, universe_company: m.company })}
              className="inline-flex items-center gap-1 text-[11px] text-slate-600 bg-slate-100 hover:bg-slate-200 border border-slate-200 px-1.5 py-0.5 rounded transition-colors"
              data-testid={`${testid}-suggest-${m.id}`}>
              <Link2 className="h-3 w-3" /> Link to {m.company}{m.location ? ` (${m.location})` : ""}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
